export interface PayableTypeGroup<T> {
  payableType: string;
  lines: T[];
}

/**
 * Group rows by the `payable_type` actually present in the payload, preserving first-seen order.
 *
 * Deriving the groups from the data (rather than a hardcoded `['indemnity', 'expenses']`) keeps
 * the helper agnostic to the payload's casing — the transactions_history endpoint capitalizes it,
 * e.g. "Indemnity", while the recovery-group endpoint sends it lowercase — and never drops a row
 * whose `payable_type` is anything unexpected.
 */
const groupByPayableType = <T extends { payable_type?: string }>(
  rows: T[] | null | undefined
): PayableTypeGroup<T>[] => {
  const groups: PayableTypeGroup<T>[] = [];
  const byType = new Map<string, PayableTypeGroup<T>>();
  (rows ?? []).forEach((row) => {
    const payableType = row.payable_type || 'Other';
    let group = byType.get(payableType);
    if (!group) {
      group = { payableType, lines: [] };
      byType.set(payableType, group);
      groups.push(group);
    }
    group.lines.push(row);
  });
  return groups;
};

export default groupByPayableType;
